import React from 'react'
import ManagerDashboardWapper from '../../../layout/wrapper/ManagerDashboardWapper'
import styles from '../../../styles/pages/user/qcagentdashboard/qc-dashboard-notification.module.scss'
import { Box, Paper, Stack } from '@mui/material'
import ManagerNotificationFilter from '../../../components/ManagerNotificationFilter/ManagerNotificationFilter'
import ManagerNotificationTab from '../../../components/ManagerNotificationTab/ManagerNotificationTab'
import QcDashboardWrapper from '../../../layout/wrapper/QcDashboradWrapper'
import QcNotificationFilter from '../../../components/QcNotificationFilter/QcNotificationFilter'
import QcNotificationTab from '../../../components/QcNotificationTab/QcNotificationTab'

export default function QcNotification() {
    return (
        <QcDashboardWrapper>
            <Paper elevation={0} className={styles.pageManager}>
                <Stack direction='row' flexWrap='wrap' className={styles.notificationWrapper}>
                    <QcNotificationFilter />
                    <Box className={`${styles.tabsNotification} ${styles.tabpanelCenter}`}>
                        <Box className={styles.tabsInner}>
                            <QcNotificationTab />
                        </Box>
                    </Box>
                </Stack>
            </Paper>
        </QcDashboardWrapper>
    )
}
